import type { SubsPlanType } from '@/app/types';

const ULTIMATE_OR_HIGHER_PLANS: SubsPlanType[] = ['ultimate_v2', 'team_v2'];

export const isUltimateOrHigherPlan = (plan?: string | null): boolean => {
  return ULTIMATE_OR_HIGHER_PLANS.includes((plan ?? '') as SubsPlanType);
};

const TEAM_PLANS: SubsPlanType[] = ['team_v2'];

export const isTeamPlan = (plan?: string | null): boolean => {
  return TEAM_PLANS.includes((plan ?? '') as SubsPlanType);
};
